import React, { useState } from 'react';
import {ReviewUnit} from "@onegovbugs/onegov-react-components";
import styles from "./ReviewUnitApplication.module.scss";

export const AttachmentReviewUnit = ({props, attachmentDetails, onEditUrl}) => {   
    const [poiFilesAttached] = useState(attachmentDetails ? JSON.parse(attachmentDetails.poiDocumentList) : []);
    
    return (
        <ReviewUnit
            title={"Attachments"}
            onEdit={() => props.history.push({
                pathname: onEditUrl,
              })}  
        >
            <div className={`row ${styles.infoLine}`}>
                <div className={"col-12"}>
                    {poiFilesAttached.map((el, i) => (
                        <div className={styles.fileList} key={"attachment-" + i}>
                            {i > 0 && (
                            <>
                                <br />
                                <hr />
                                <br />
                            </>
                            )}
                            <p>{el.attachmentType}</p>
                            <p>{el.name}</p>
                            <p>{el.description}</p>
                        </div>
                    ))}
                    {poiFilesAttached.length == 0 && <p>No Proof of Identity attachment attached</p>}
                </div>        
            </div>
        </ReviewUnit>      
    )
}